export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},

			{
				title: "品牌输出方",
				children: [{
						title: "企业名称",
						prop: "xfs_6_x_1",
						width: "150px",
						custom: true,
					},
					{
						title: "统一社会信用代码",
						prop: "xfs_6_x_2",
						width: "150px",
						custom: true,
					},
				]
			},
			{
				title: "品牌输入方",
				children: [{
						title: "企业名称",
						prop: "xfs_6_x_3",
						width: "150px",
						custom: true,
					},
					{
						title: "统一社会信用代码",
						prop: "xfs_6_x_4",
						width: "150px",
						custom: true,
					},
				]
			},
			{
				title: "卷烟条包装商品条码",
				prop: "xfs_6_x_5",
				width: "150px",
				custom: true,
			},
			{
				title: "卷烟牌号规格",
				prop: "xfs_6_x_6",
				width: "150px",
				custom: true,
			},
			{
				title: "销量",
				prop: "xfs_6_x_7",
				width: "150px",
				custom: true,
			}, {
				title: "销售价格",
				prop: "xfs_6_x_8",
				width: "150px",
				custom: true,
			}, {
				title: "销售额",
				prop: "xfs_6_x_9",
				width: "150px",
				custom: true,
			}, {
				title: "品牌输入方已缴纳税款",
				prop: "xfs_6_x_10",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [
			{}, {
				xfs_6_x_1: {
					cellCode: "xfs_6_1_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_2: {
					cellCode: "xfs_6_1_2",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_3: {
					cellCode: "xfs_6_1_3",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_4: {
					cellCode: "xfs_6_1_4",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_5: {
					cellCode: "xfs_6_1_5",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_6: {
					cellCode: "xfs_6_1_6",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_7: {
					cellCode: "xfs_6_1_7",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_8: {
					cellCode: "xfs_6_1_8",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_9: {
					cellCode: "xfs_6_1_9",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_6_x_10: {
					cellCode: "xfs_6_1_10",
					cellType: "1",
					cellVal: "0.00"
				},
			},

		],
	}
	return obj
}